import React, { useEffect, useState } from "react";
import { getPredefine, setNewMessages } from "../../services/firebase";

export default function Messages() {
  const [data, setData] = useState([]);
  useEffect(() => {
    getPredefine().then((resp) => {
      setData(resp);
    });
  }, []);
  const handleChange = (index) => (e) => {
    data[index] = e.target.value;
    setData([...data]);
  };
  const handleAddMEss = () => {
    data.push("");
    setData([...data]);
  };
  const handleSave = () => {
    setNewMessages(data);
  };
  const handleDelete = (index) => () => {
    data.splice(index, 1);
    setData([...data]);
  };
  return (
    <div>
      Messages
      {data.map((elem, index) => {
        return (
          <div key={index}>
            {" "}
            <input
              style={{ width: "50%" }}
              value={elem}
              onChange={handleChange(index)}
            />
            <input
              type={"button"}
              value="delete"
              onClick={handleDelete(index)}
            />
          </div>
        );
      })}
      <input type={"button"} value={"Add Message"} onClick={handleAddMEss} />
      <input type={"button"} value={"save"} onClick={handleSave} />
    </div>
  );
}
